import { NgxSpinnerService } from 'ngx-spinner';
import { Consignment, ConsignmentService } from '../../../Services/consignment.service';
import { Component, OnInit } from '@angular/core';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { CategoryService } from 'src/app/Services/category.service';
import { Artist, ArtistsService } from 'src/app/Services/artists.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { ConsignmentCommentRequest } from '../../artist-components/view-consignment/view-consignment.component';
import { MenuItem } from 'primeng/api';
import { StripePlans } from 'src/app/models/stripe.model';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-consignment-product-selection',
    templateUrl: './consignment-product-selection.component.html',
    styleUrls: ['./consignment-product-selection.component.css'],
    providers: [CategoryService, ConsignmentService, SubscriptionRulesService],
    standalone: false
})
export class ConsignmentProductSelectionComponent implements OnInit {
  // Component properties
  public isProfileDialogVisible: boolean = false;
  public showProductDialog = false;
  public consignmentId!: string;
  public consignmentArtist?: Artist;
  public consignment!: Consignment;
  public consignmentProducts: ArtistProduct[] = [];
  public acceptedConsignmentProductIds: string[] = [];
  public authConfig!: AuthConfig;
  public showArtistOverlayPanel: boolean = false;
  public selectedConsignmnetPoduct!: ConsignmentCommentRequest;
  public showCommentDialog: boolean = false;
  public displayEmojiDialog: boolean = false;
  public items: MenuItem[] | undefined;
  public home: MenuItem | undefined;
  public isFreePlanUser: boolean = true;
  public stripePlans: StripePlans[] = [];
  public isStripeDisplayPlansDialogVisible: boolean = false;
  public isOnFreeTrial: boolean = false;
  public hasFreeTrailEnded: boolean | undefined;
  public ishavelimt: boolean = false;
  public limit: number = 0;
  public displayUpgreadAccountDialog: boolean = false;
  public selectedProductId: any;

  // Constructor with dependency injection
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private artistService: ArtistsService,
    private consignmentService: ConsignmentService,
    private subscriptionRulesService: SubscriptionRulesService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private transloco: TranslocoService
  ) {
    // Initialize selectedConsignmnetPoduct
    this.selectedConsignmnetPoduct = new ConsignmentCommentRequest();
  }

  public ngOnInit(): void {
    // Get authentication configuration
    this.authConfig = this.authService.getAuthConfig();

    // Subscribe to route parameters to get consignment ID
    this.route.params.subscribe((params) => {
      this.consignmentId = params['consignmentId'];
    });

    // Check if user is a gallery and fetch consignment data
    if (this.authConfig.IsGallery) {
      this.getConsignment(this.consignmentId);
      this.getConsignmentProducts(this.consignmentId);

      // Check if more consignment products can be accepted
      this.subscriptionRulesService.CanAcceptMoreConsignmentProducts().subscribe(
        (response) => {
          this.ishavelimt = response.IsHaveLimit;
          this.limit = response.Limit;
          console.log('Fetched consignment:', response);
        },
        (error) => {
          console.error('Error fetching consignment settings:', error);
        }
      );

      // Set user plan status
      this.isFreePlanUser = this.authService.isFreePlanUser();
      this.isOnFreeTrial = this.authService.isOnFreetrial();
      this.hasFreeTrailEnded = this.authService.hasFreeTrialEnded();
    }

    // Initialize product sync requests
    this.selectedConsignmnetPoduct.ProductSyncRequests = [];
  }

  // Navigate back in browser history
  public back($event: any): void {
    history.back();
  }

  // Show profile dialog
  public showProfileDialog(): void {
    this.isProfileDialogVisible = true;
  }

  // Fetch consignment details by ID
  public getConsignment(consignmentId: string): void {
    this.consignmentService.getConsignmentById(consignmentId).subscribe(
      (consignment: Consignment) => {
        this.consignment = consignment;
        // Set breadcrumb items
        this.items = [
          { label: 'Consignments', routerLink: ['/view-consignments'] },
          { label: `Accept "${consignment?.Name}" Products` }
        ];
        this.home = { icon: 'pi pi-home', routerLink: '/' };

        // Fetch artist details if artist ID exists
        if (this.consignment?.ArtistId) {
          this.artistService.getArtistById(this.consignment?.ArtistId).subscribe(
            (artist: Artist) => {
              this.consignmentArtist = artist;
            },
            (error) => {
              console.error(error);
              this.ngxSpinnerService.hide();
            }
          );
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  // Fetch consignment products by ID
  public getConsignmentProducts(consignmentId: string): void {
    this.consignmentProducts = [];
    this.ngxSpinnerService.show();
    this.consignmentService.getConsignmentProducts(consignmentId).subscribe(
      (consignmentProducts) => {
        this.consignmentProducts = consignmentProducts;
        this.consignmentProducts.forEach((product) => {
          product.IsAccepted = true; // Mark as selected
          this.addProductToAcceptedList(product.Id); // Add to accepted list
        });
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  // Toggle product selection for synchronization
  public selectProductTosync($event: MouseEvent, rowData: ArtistProduct): void {
    $event.stopPropagation();
    // Check if user is on free plan and limit is reached
    if (this.isFreePlanUser) {
      if ((this.ishavelimt && this.acceptedConsignmentProductIds.length >= this.limit) || !this.ishavelimt) {
        this.displayUpgreadAccountDialog = true;
        console.log('Product limit reached for Free Plan user');
        console.log('Accepted Products Count:', this.acceptedConsignmentProductIds.length);
        console.log('Limit:', this.limit);
        return;
      }
    }

    // Toggle product acceptance
    this.toggleProductAcceptance(rowData);
  }

  // Select or unselect all products
  public selectAllProducts(): void {
    // Check if user is on free plan and limit is reached
    if (this.isFreePlanUser) {
      if ((this.ishavelimt && this.acceptedConsignmentProductIds.length >= this.limit) || !this.ishavelimt) {
        this.displayUpgreadAccountDialog = true;
        console.log('Product limit reached for Free Plan user, cannot toggle selection');
        return;
      }
    }

    // Toggle selection for all products
    const allSelected = this.consignmentProducts.every((product) => product.IsAccepted);
    this.consignmentProducts.forEach((product) => {
      product.IsAccepted = !allSelected;
      if (product.IsAccepted && !this.acceptedConsignmentProductIds.includes(product.Id)) {
        this.acceptedConsignmentProductIds.push(product.Id);
      } else if (!product.IsAccepted) {
        this.acceptedConsignmentProductIds = this.acceptedConsignmentProductIds.filter(
          (id) => id !== product.Id
        );
      }
    });
    console.log('Selected Products:', this.acceptedConsignmentProductIds);
  }

  // Toggle acceptance status of a single product
  private toggleProductAcceptance(product: ArtistProduct): void {
    const productId = product.Id;
    product.IsAccepted = !product.IsAccepted;
    if (product.IsAccepted) {
      this.addProductToAcceptedList(productId);
    } else {
      this.removeProductFromAcceptedList(productId);
    }
  }

  // Add product ID to accepted list
  private addProductToAcceptedList(productId: string): void {
    if (!this.acceptedConsignmentProductIds.includes(productId)) {
      this.acceptedConsignmentProductIds.push(productId);
    }
  }

  // Remove product ID from accepted list
  private removeProductFromAcceptedList(productId: string): void {
    const index = this.acceptedConsignmentProductIds.indexOf(productId);
    if (index !== -1) {
      this.acceptedConsignmentProductIds.splice(index, 1);
    }
  }

  // Show upgrade account dialog
  public onUpgradeAccount(): void {
    this.isStripeDisplayPlansDialogVisible = true;
  }

  // Show comment dialog for consignment acceptance
  public showProductDetailsDialog(): void {
    this.showCommentDialog = true;
  }

  // Open comment dialog (alias for showProductDetailsDialog)
  public openminiDilog(): void {
    this.showCommentDialog = true;
  }

  // Accept consignment and close comment dialog
  public acceptConsignment(): void {
    this.showCommentDialog = false;
    this.acceptConsignmentProducts(event);
  }

  // Accept selected consignment products
  public acceptConsignmentProducts($event: any): void {
    // Validate accepted product IDs
    if (!this.acceptedConsignmentProductIds || this.acceptedConsignmentProductIds.length === 0) {
      console.error('No accepted product IDs found. Please ensure products are selected.');
      this.notificationsService.showNotification(
        this.transloco.translate('consignmentProductSelection.errorTitle'),
        this.transloco.translate('consignmentProductSelection.noProductsSelected'),
        NotificationTypes.Error
      );
      return;
    }

    // Assign accepted product IDs to payload
    this.selectedConsignmnetPoduct.ConsignmentProductIds = [...this.acceptedConsignmentProductIds];
    console.log('Payload to API:', this.selectedConsignmnetPoduct);

    // Make API call to accept consignment products
    this.ngxSpinnerService.show();
    this.consignmentService.acceptConsignmentProduct(this.consignmentId, this.selectedConsignmnetPoduct).subscribe(
      (response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.router.navigate(['/view-consignments']);
          this.notificationsService.showNotification(
            this.transloco.translate('consignmentProductSelection.successTitle'),
            this.transloco.translate('consignmentProductSelection.productsAccepted'),
            NotificationTypes.Success
          );
        } else {
          this.isStripeDisplayPlansDialogVisible = true;
        }
      },
      (error) => {
        console.error('Error occurred while accepting consignment:', error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  // Navigate to artist profile
  public viewArtistDetails(userName: string): void {
    this.router.navigate(['/profile', userName]);
  }

  // Navigate to product details
  public goToProductDetails(product: ArtistProduct): void {
    this.router.navigate(['/', product.ArtistId, 'artworks', product.Id]);
  }

  // Toggle emoji dialog visibility
  public openEmojiDialog(): void {
    this.displayEmojiDialog = !this.displayEmojiDialog;
  }

  // Add selected emoji to comment
  public addEmoji(emoji: string): void {
    console.log('Selected emoji:', emoji);
    this.selectedConsignmnetPoduct.ConsignmentAcceptComment =
      (this.selectedConsignmnetPoduct.ConsignmentAcceptComment || '') + emoji;
    this.displayEmojiDialog = false;
  }

  // Close emoji dialog
  public closeEmojiDialog($event: any): void {
    this.displayEmojiDialog = false;
  }

  // Show artist overlay panel
  public onShowArtistOverlay($event: any): void {
    this.showArtistOverlayPanel = true;
  }

  // Close artist overlay panel
  public onArtistOverlayClosed($event: any): void {
    this.showArtistOverlayPanel = false;
  }

  // Check if a date is today
  public isToday(date: Date): boolean {
    const today = new Date();
    const providedDate = new Date(date);
    return (
      providedDate.getFullYear() === today.getFullYear() &&
      providedDate.getMonth() === today.getMonth() &&
      providedDate.getDate() === today.getDate()
    );
  }

  // Calculate days since dispatch
  public dispatchedDaysAgo(date: Date): number {
    const currentDate = new Date();
    const dispatchedDate = new Date(date);
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    return Math.round(Math.abs((currentDate.getTime() - dispatchedDate.getTime()) / oneDay));
  }

  // Show stripe payment plans dialog
  public onUpgradePlan(): void {
    this.isStripeDisplayPlansDialogVisible = true;
  }

  // Close stripe payment plans dialog
  public onCloseStripePaymentDailog($event: boolean): void {
    this.isStripeDisplayPlansDialogVisible = $event;
  }

  // Close product details dialog
  public closeProductDialog(): void {
    this.showProductDialog = false;
  }

  // Show product details dialog
  public showProductDeatils(event: Event, selectedProductId: string): void {
    this.selectedProductId = selectedProductId;
    this.showProductDialog = true;
  }
}